import { useSelector } from 'react-redux';

import { DEFAULT_MINIMUM_SCHEDULED_TIME_SECONDS } from '@app/constants/organization';
import { WRITING_ASSISTANT_ACTIONS } from '@app/services/writing-assistant';
import { StateType } from '@app/types/reducer-state';

export const useOrganizationId = () =>
  useSelector((state: StateType) => state?.organizations?._id || '');

export const useOrganization = () =>
  useSelector((state: StateType) => state?.organizations || {});

export const useOrganizationDisplayName = () =>
  useSelector(
    (state: StateType) =>
      state?.organizations?.displayName || state?.organizations?.name || '',
  );

export const useMinimumScheduledTime = () =>
  useSelector(
    (state: StateType) =>
      state?.organizations?.organizationSettings?.minimumScheduledTimeSeconds ??
      DEFAULT_MINIMUM_SCHEDULED_TIME_SECONDS,
  );

export const useWritingAssistantEnabledActions = () =>
  useSelector(
    (state: StateType) =>
      state?.organizations?.organizationSettings?.writingAssistant
        ?.enabledActions ?? WRITING_ASSISTANT_ACTIONS,
  );
